import svg from "./candidate-prediction-icon.svg?react";
import { makeSvgIcon } from "./svg-icon";

export const CandidatePredictionIcon = makeSvgIcon(
  svg,
  (theme) => theme.palette.candidate.main,
);

export default CandidatePredictionIcon;
